import React, { Component } from "react";
import { isOnline } from "../../utils/utils";

export default class Protocols extends Component {

  componentDidMount() {
    let {type} = this.props.location.query;
    console.log(this.props.location,'search----', type)
    // 区分测试和生产环境 https://www.lujing56.cn
    const prefix = isOnline ? 'https://www.lujing56.cn' : 'https://statictest.tf56.com';
    switch(type) {
      case 'user':
        window.open(`${prefix}/policyH5/p_userprotocol.html`, '_self')
        break;
      case 'privacy':
        window.open(`${prefix}/policyH5/p_law.html`, '_self')
        break;
      case 'privacySimple':
        window.open(`${prefix}/policyH5/p_law_simple.html`, '_self')
        break;
      case 'shareList':
        window.open(`${prefix}/policyH5/lujingApp_sdk_info.html`, '_self')
        break;
      default:
        break;
    }
  }

  render() {
    return (
      <div></div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/protocols/index.js